import { render, staticRenderFns } from "./TrangQuanLyNguoiDung.vue?vue&type=template&id=02be917a&"
import script from "./TrangQuanLyNguoiDung.vue?vue&type=script&lang=js&"
export * from "./TrangQuanLyNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports